import React from 'react';

import { v4 as uuid } from 'uuid';

import { Button, Tooltip, Flex, Divider } from 'antd';
import { FilterFilled, SettingOutlined } from '@ant-design/icons';
import { ButtonType, ButtonColorType, ButtonVariantType } from 'antd/es/button';
import { SizeType } from 'antd/es/config-provider/SizeContext';

import DropdownControl from '@controls/button/dropdown-control';

import './toolbar.css';

interface IFilterButton {
    active: boolean;
    onHideFilter: () => void;
}

interface IToolbar {
    commands: Array<ICommandProps>;
    farControl?: any;
    farCommands?: Array<any>;
    style?: any;
    filter?: IFilterButton;
    onShowTableSettings?: () => void;
}

export interface ICommandProps {
    key?: string;
    label?: string;
    disabled?: boolean;
    type?: ButtonType;
    color?: ButtonColorType;
    variant?: ButtonVariantType;
    icon?: React.ReactNode;
    size?: SizeType;
    showLabel?: boolean;
    style?: any;
    children?: any[];
    hidden?: boolean;
    loading?: boolean;
    onClick?: () => void;
    isDivider?: boolean;
}

const Toolbar = (props: IToolbar) => {
    const { commands, farControl, farCommands, style, filter, onShowTableSettings } = props;

    const useTableSettings: boolean = !!onShowTableSettings;

    return (
        <Flex align='center' justify='space-between' className='commands-container' style={style}>
            <Flex gap='small'>
                {commands.map((item: ICommandProps) => {
                    return (
                        !item.hidden && (
                            <Tooltip key={item.key ?? uuid()} placement='top' title={item.label}>
                                {item.isDivider && !item.hidden ? (
                                    <Divider orientation='vertical' style={{ height: 'auto', marginInline: 2 }} />
                                ) : item.children ? (
                                    <DropdownControl item={item} />
                                ) : (
                                    <Button
                                        variant={item.variant}
                                        color={item.color}
                                        disabled={item.disabled}
                                        type={item.type}
                                        icon={item.icon}
                                        style={item.style}
                                        onClick={item.onClick}
                                        size={item.size || 'middle'}
                                        loading={item.loading}
                                    >
                                        {item.showLabel && item.label}
                                    </Button>
                                )}
                            </Tooltip>
                        )
                    );
                })}
            </Flex>

            <Flex gap='small'>
                {farControl}
                {farCommands?.map((item: any) => {
                    return (
                        <Tooltip key={item.key ?? uuid()} placement='left' title={item.label}>
                            <Button disabled={item.disabled} type={item.type} icon={item.icon} style={item.style} onClick={item.onClick} />
                        </Tooltip>
                    );
                })}

                {useTableSettings && (
                    <Tooltip key='tableSettings' placement='bottom' title='Show table settings'>
                        <Button icon={<SettingOutlined />} onClick={() => onShowTableSettings && onShowTableSettings()} />
                    </Tooltip>
                )}

                {filter && (
                    <Tooltip key='filter' placement='left' title='Фильтр'>
                        <Button
                            type={filter.active ? 'primary' : 'default'}
                            icon={<FilterFilled />}
                            onClick={() => filter.onHideFilter && filter.onHideFilter()}
                        />
                    </Tooltip>
                )}
            </Flex>
        </Flex>
    );
};

export default Toolbar;
